import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { useCallback } from "react";
import { FormProvider, useFieldArray, useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import Button from "../../../../components/Common/Button/Button";
import Input from "../../../../components/Common/Input/Input";
import Loader from "../../../../components/Common/Loader/Loader";
import PlusIcon from "../../../../components/Common/SvgIcons/CommonIcons/PlusIcon";
import DeleteIcon from "../../../../components/Common/SvgIcons/TableIcons/DeleteIcon";
import Tooltip from "../../../../components/Common/ToolTip/Tooltip";
import {
  addUserEmailDetailsActionHandler,
  getUserEmailDetailsActionHandler,
} from "../../../../store/actions/actionHandlers/adminActionHandler/organizationActionHandler";
import { AddUserForSupportSchema } from "../../../../utils/mainTabs/admin/organizationSettings/addUserForSupportSchema";
import classes from "./AddUserForSupport.module.scss";
import { FormattedMessage, injectIntl } from "react-intl";

const AddUserForSupport = ({ intl }) => {
  const dispatch = useDispatch();
  const [isChecked, setIsChecked] = useState(false);
  const [storeIndex, setStoreIndex] = useState("");
  const [emailData, setEmailData] = useState([]);

  const adminStateReducer = useSelector((state) => state.adminReducer);
  const { organizationSettingsReducer } = adminStateReducer;
  const { getUserEmailDetailsLoader, addUserEmailDetailsLoader } =
    organizationSettingsReducer;
  const methods = useForm({
    defaultValues: { EmailList: [{ email: "" }] },
    resolver: yupResolver(AddUserForSupportSchema),
    mode: "onChange",
  });
  const {
    handleSubmit,
    control,
    reset,
    setValue,
    formState: { isValid, errors, isDirty },
  } = methods;
  const { fields, append, remove } = useFieldArray({
    control,
    name: "EmailList",
  });

  const getUserEmailDetails = useCallback(() => {
    dispatch(getUserEmailDetailsActionHandler()).then((data) => {
      if (data.length > 0) {
        setIsChecked(true);
        setEmailData(data);
        let formData = {
          EmailList: data,
        };
        reset(() => formData);
      } else {
        setEmailData([]);
      }
    });
  }, [dispatch, reset, setIsChecked, setEmailData]);

  useEffect(() => {
    getUserEmailDetails();
  }, [getUserEmailDetails]);
  //useEffect(() => {}, [setActiveEmail, activeEmail]);

  const submitEmailForSupport = (data) => {
    dispatch(addUserEmailDetailsActionHandler(data.EmailList)).then(() => {
      if (storeIndex === 0) {
        setIsChecked(false);
      }
      getUserEmailDetails();
    });
  };
  // useEffect(() => {
  //   dispatch(getUserEmailDetailsActionHandler()).then((data) => {
  //     if (data.length > 0) {
  //       setIsChecked(true);
  //       let formData = {
  //         EmailList: data,
  //       };
  //       reset(() => formData);
  //     }
  //   });
  // }, [dispatch, setIsChecked, reset]);

  const handleOnChange = (e) => {
    setIsChecked(!isChecked);
    if (e.target.checked) {
      setValue("EmailList", [{ email: "" }]);
      dispatch(getUserEmailDetailsActionHandler()).then((data) => {
        if (data.length > 0) {
          let formData = {
            EmailList: data,
          };
          reset(() => formData);
        }
      });
    }
  };
  const handleDeleteIndex = (index) => {
    remove(index);
    setStoreIndex(index);
  };
  return (
    <FormProvider {...methods}>
      <form
        className={classes.addUserForSupport}
        onSubmit={handleSubmit(submitEmailForSupport)}
      >
        {getUserEmailDetailsLoader ? (
          <Loader height={50} width={50} />
        ) : (
          <div className={classes.addUserForSupport__mainContainer}>
            <div
              className={classes.addUserForSupport__mainContainer__subheading}
            >
              <FormattedMessage id="LIKETORECEIVE_CC" />
              <Input
                name="ShouldAddUser"
                type="checkbox"
                width="2"
                height="2"
                // checked
                // value="true"
                // disabled
                gap="0"
                value={"AddUser"}
                checked={isChecked}
                onChange={handleOnChange}
                //disabled={emailData?.length > 0}
                style={{
                  pointerEvents: emailData?.length > 0 ? "none" : "auto",
                  cursor: emailData?.length > 0 ? "not-allowed" : "pointer",
                  opacity: emailData?.length > 0 ? "0.4" : "1",
                  minHeight: "2rem",
                  borderRadius: "0.8rem",
                  padding: "1.3rem",
                  width: "2rem",
                }}
              />
            </div>
            {isChecked && (
              <div
                className={classes.addUserForSupport__mainContainer__fieldsMain}
              >
                <div
                  className={
                    classes.addUserForSupport__mainContainer__fieldsMain__inner
                  }
                >
                  <label
                    htmlFor={`EmailList.${0}.email`}
                    className={classes.addUserForSupport__mainContainer__label}
                  >
                    Email Address
                  </label>
                  <Button
                    label={"Add"}
                    height="3"
                    width="10.5"
                    icon={PlusIcon}
                    onClick={() => {
                      append({
                        email: "",
                      });
                    }}
                    light
                    type="button"
                    disabled={fields?.length > 2}
                  />
                </div>
                {fields.map((email, index, emailArr) => {
                  return (
                    <div
                      key={index}
                      className={
                        classes.addUserForSupport__mainContainer__fieldContainer
                      }
                    >
                      <Input
                        name={`EmailList.${index}.email`}
                        // label={"Email Address"}
                        placeholder={intl.formatMessage({
                          id: `USERMANAGE_PLACEHOLDER_EMAILID`,
                        })}
                        error={errors?.EmailList?.[index]?.email?.message}
                        gap={0}
                      />
                      <Tooltip content={"Delete"} direction={"bottom"}>
                        <div
                          onClick={() => handleDeleteIndex(index)}
                          className={
                            classes.addUserForSupport__mainContainer__fieldContainer__icon
                          }
                        >
                          <DeleteIcon />
                        </div>
                      </Tooltip>
                      {/* {emailArr.length > 1 && (
                        <Tooltip content={"Delete"} direction={"bottom"}>
                          <div
                            onClick={() => remove(index)}
                            className={
                              classes.addUserForSupport__mainContainer__fieldContainer__icon
                            }
                          >
                            <DeleteIcon />
                          </div>
                        </Tooltip>
                      )} */}
                      {/* {index === emailArr.length - 1 && (
                        <Button
                          label={"Add Another"}
                          height="3"
                          width="13.5"
                          icon={PlusIcon}
                          onClick={() => {
                            append({
                              email: "",
                            });
                          }}
                          light
                          type="button"
                          disabled={emailArr.length > 2}
                        />
                      )} */}
                    </div>
                  );
                })}
                <Button
                  label={<FormattedMessage id="SAVE_TXT" />}
                  disabled={isDirty && !isValid}
                  type="submit"
                  dark
                  small
                  loading={addUserEmailDetailsLoader}
                />
              </div>
            )}
          </div>
        )}
      </form>
    </FormProvider>
  );
};

export default injectIntl(AddUserForSupport);
